/**
 * Subtle scroll reveals for M&M section blocks.
 * Respects prefers-reduced-motion; heroes fade in on load only.
 */

const HERO_SECTION = /(?:^|\s)(?:home|ns|sv|sg|spd|ct)-hero(?:\s|$)/;
const HERO_INNER = [
  '.home-hero-content',
  '.ns-hero-inner',
  '.sv-intro-inner',
  '.sg-intro-inner',
  '.spd-hero-inner',
  '.ct-form-inner',
].join(', ');

const STAGGER_GRIDS = [
  '.home-cards-grid',
  '.sv-method-steps',
  '.sg-process-grid',
  '.spd-others-grid',
  '.ns-quality-grid',
].join(', ');

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function revealNow(el) {
  el.classList.add('is-visible');
}

function observeReveal(el) {
  if (!('IntersectionObserver' in window)) {
    revealNow(el);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        revealNow(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12,
    },
  );

  observer.observe(el);
}

function initHeroes() {
  document.querySelectorAll('.site-main section').forEach((section) => {
    if (!HERO_SECTION.test(section.className)) {
      return;
    }

    const inner = section.querySelector(HERO_INNER) || section.querySelector('.wrap');
    if (!inner) {
      return;
    }

    inner.classList.add('mym-reveal', 'mym-reveal--hero');
    window.requestAnimationFrame(() => {
      window.setTimeout(() => revealNow(inner), 80);
    });
  });
}

function initSections() {
  document.querySelectorAll('.site-main section').forEach((section) => {
    if (section.parentElement?.closest('section')) {
      return;
    }

    if (HERO_SECTION.test(section.className)) {
      return;
    }

    if (section.querySelector(STAGGER_GRIDS)) {
      return;
    }

    section.classList.add('mym-reveal');
    observeReveal(section);
  });
}

function initStaggerGrids() {
  document.querySelectorAll(STAGGER_GRIDS).forEach((grid) => {
    const items = [ ...grid.children ];
    if (items.length < 2) {
      return;
    }

    items.forEach((item, index) => {
      item.classList.add('mym-reveal', 'mym-reveal--scale');
      item.style.setProperty('--mym-reveal-delay', `${index * 70}ms`);
      observeReveal(item);
    });
  });
}

export default function initMymReveal() {
  if (prefersReducedMotion()) {
    return;
  }

  initHeroes();
  initSections();
  initStaggerGrids();
}
